import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NavigationService } from 'src/app/providers/navigation.service';
import { NewReminderComponent } from '../new-v2-component/new-reminder/new-reminder.component';
import { MatDialog } from "@angular/material/dialog";

export interface Reminder {
  name: string;
  triggerDate: string;
  triggerTime: string;
  notification: string;
  frequency: string;
  status: string;
  createdOn: string;
}

const REMINDER_DATA: Reminder[] = [
  {
    name: 'Hair spa',
    triggerDate: 'Feb 5, 2026',
    triggerTime: '10:30 AM',
    notification: 'You Have A Scheduled Session.',
    frequency: 'Recurring / 30 Days',
    status: 'Active',
    createdOn: 'Jan 10, 2026'
  },
  {
    name: 'Special diet',
    triggerDate: 'Feb 12, 2026',
    triggerTime: '10:30 AM',
    notification: 'You Need To Visit Gym.',
    frequency: 'One Time',
    status: 'Paused',
    createdOn: 'Jan 30, 2026'
  },

   {
    name: 'Facial cleanup',
    triggerDate: 'Mar 1, 2026',
    triggerTime: '04:00 PM',
    notification: 'Facial cleanup appointment reminder.',
    frequency: 'Recurring / 45 Days',
    status: 'Active',
    createdOn: 'Feb 1, 2026'
  },
  {
    name: 'Gym workout',
    triggerDate: 'Feb 6, 2026',
    triggerTime: '06:00 AM',
    notification: 'Time for your daily gym workout.',
    frequency: 'Recurring / Daily',
    status: 'Active',
    createdOn: 'Jan 5, 2026'
  },
  {
    name: 'Haircut',
    triggerDate: 'Mar 10, 2026',
    triggerTime: '11:00 AM',
    notification: 'It’s time for your regular haircut.',
    frequency: 'Recurring / 60 Days',
    status: 'Active',
    createdOn: 'Feb 15, 2026'
  },
  {
    name: 'Skin care routine',
    triggerDate: 'Feb 7, 2026',
    triggerTime: '09:00 PM',
    notification: 'Don’t forget your night skin care routine.',
    frequency: 'Recurring / Daily',
    status: 'Paused',
    createdOn: 'Jan 20, 2026'
  },
];

@Component({
  selector: 'sm-service-reminder',
  templateUrl: './service-reminder.component.html',
  styleUrls: ['./service-reminder.component.scss']
})
export class ServiceReminderComponent implements OnInit {

  displayedColumns: string[] = [
    'name',
    'triggerDate',
    'triggerTime',
    'notification',
    'frequency',
    'status',
    'createdOn',
    'actions'
  ];

  dataSource = new MatTableDataSource<Reminder>(REMINDER_DATA);

  constructor(private navservice: NavigationService, private dialog: MatDialog,) {
    this.navservice.hideSidebarAndNav = false;
  }

  ngOnInit(): void {}

  edit(row: Reminder) {
    console.log('Edit', row);
  }

  pause(row: Reminder) {
    console.log('Pause', row);
  }

  delete(row: Reminder) {
    console.log('Delete', row);
  }
  
openreminder(){
    this.dialog.open(NewReminderComponent,{
      width:'600px',
      disableClose:true,
  
    })
}

}


